import Home from './Home';
import LiveKitConsentContainer from './LiveKitConsentContainer';

import TelemedicineContext from '../../context/telemedicine';
import { createConsentTerm } from '../../services/telemedicine-term';
import { LIVEKIT_PROVIDER } from '../../utils/telemedicine';

import { showErrorToast, DateUtils } from '@amigoapp/doca-react';
import React, { useCallback, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const HomeContainer = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const { telemedicine, updateTelemedicine } = useContext(TelemedicineContext);

	const onConsentTermClick = useCallback(() => {
		navigate('/consent-term');
	}, [navigate]);

	const onCreateConsentTermClick = useCallback(async () => {
		setLoading(true);

		const { data } = await createConsentTerm();

		if (data) {
			window.socket.emit('telemedicine:patient-connected');
			updateTelemedicine({ signed_at: DateUtils.now() });
			navigate('/waiting-room');
		} else {
			showErrorToast('Não foi possível criar o termo.');
		}

		setLoading(false);
	}, [navigate, updateTelemedicine]);

	if (telemedicine?.provider === LIVEKIT_PROVIDER) {
		return <LiveKitConsentContainer />;
	}

	return (
		<Home
			date={telemedicine.attendance?.start_date ? telemedicine.attendance.start_date : telemedicine.created_at}
			loading={loading}
			user={telemedicine.user}
			onConsentTermClick={onConsentTermClick}
			onCreateConsentTermClick={onCreateConsentTermClick}
		/>
	);
};

export default HomeContainer;
